import React, {useMemo} from 'react';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';

import SlotDialog from '../../../components/Forms/SlotDialog';
import UpdateSlot from '../../../components/Forms/UpdateSlot';
import NewEvent from '../../../components/Forms/NewEvent';
import Confirmation from '../../../components/Forms/Confirmation';
import useStyles from '../../styles';

const Details = ({
  path,
  setPath,
  data,
  onUpdateSlot,
  onEvent,
  onDeleteSlot,
  // slotData,
  // handleSlotChange,
}) => {

  const classes = useStyles();

  const EventMemo = useMemo(() =>
    <NewEvent
      onClose={() => setPath('root')}
      onSubmit={onEvent}
    />, [onEvent, setPath]
  );

  const DeleteMemo = useMemo(() =>
    <Confirmation
      message='Gostaria de apagar permanentemente a Pré Carga?'
      onSubmit={onDeleteSlot}
      onClose={() => setPath('root')}
    />, [setPath, onDeleteSlot]
  );

  const DescriptionMemo = useMemo(() =>
    <SlotDialog {...{data, setPath}}/>,
    [data, setPath]
  );

  const UpdateMemo = useMemo(() =>
    <UpdateSlot {...{data, setPath, onUpdateSlot}}/>,
    [data, setPath, onUpdateSlot]
  );

  const Switch = useMemo(() => {
    switch(path) {
      case 'delete': return DeleteMemo;
      case 'event': return EventMemo;
      case 'detail': return DescriptionMemo;
      case 'update': return UpdateMemo;
      default: return <CircularProgress/>;
    }
  }, [path, DeleteMemo, EventMemo, DescriptionMemo, UpdateMemo]);

  return <Dialog open={path !== 'root'} onClose={() => setPath('root')}>
    <Paper className={classes.dialog}>
      <Grid container justify="space-around" alignItems="center">
        {Switch}
      </Grid>
    </Paper>
  </Dialog>;
};

export default Details;
